import { createTypes } from 'reduxsauce'
 
export default createTypes(`
    PREPARE_CONTRACT
    ON_VERIFICATION_EVENT
`, {}) // options - the 2nd parameter is optional